export default __webpack_public_path__ + "static/media/alumini (5).ed383f84.JPG";